import { Zap } from "lucide-react";
import { SectionHead, FadeUp } from "@/components/Reveal";
import { STEPS } from "@/lib/content";
import { scrollToId } from "@/lib/ui";

export default function HowItWorksSection() {
  return (
    <section className="relative py-24 sm:py-32 border-t border-white/5" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          eyebrow="Three steps"
          title="How to keep your computer awake in 3 steps"
        />

        <div className="mt-16 relative grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
          <div className="hidden md:block absolute top-9 left-[16%] right-[16%] h-px bg-gradient-to-r from-neon/40 via-white/10 to-neon/40" />
          {STEPS.map((s, i) => (
            <FadeUp key={s.n} delay={i * 0.12}>
              <div className="relative" data-testid={`step-card-${i}`}>
                <div className="relative w-[72px] h-[72px] rounded-2xl bg-surface border border-neon/30 flex items-center justify-center shadow-[0_0_30px_rgba(0,255,102,0.12)]">
                  <span className="font-mono font-bold text-xl text-neon">{s.n}</span>
                </div>
                <h3 className="mt-7 font-display font-bold text-xl text-white tracking-tight">
                  <span className="text-dim font-semibold mr-2">{s.n.replace(/^0/, "")}.</span>
                  {s.title}
                </h3>
                <p className="mt-3 text-mist text-[15px] leading-relaxed max-w-sm">{s.copy}</p>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.2}>
          <div className="mt-16">
            <button
              onClick={() => scrollToId("#tool")}
              data-testid="steps-cta-button"
              className="inline-flex items-center gap-2.5 rounded-full bg-neon text-ink font-bold px-8 py-4 transition-all duration-200 hover:-translate-y-0.5 hover:bg-neonhover hover:shadow-[0_0_36px_rgba(0,255,102,0.45)]"
            >
              <Zap size={17} strokeWidth={2.5} />
              Start now — it's free
            </button>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
